<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="h1" data-automation-id="dialog-title">{{ data.title }}</h2>
  <button
    mat-icon-button
    [mat-dialog-close]="false"
    aria-label="Close {{ data.title }} dialog"
    data-automation-id="dialog-close-button"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p [innerHTML]="data.body"></p>
  <div class="dialog-footer">
    <button
      *ngFor="let button of data.buttons; index as i; first as isFirst"
      mat-button
      [class]="
        button.default === false
          ? 'mat-simple-button'
          : isFirst
          ? 'mat-flat-button'
          : 'mat-stroked-button'
      "
      color="primary"
      data-automation-id="generic-dialog_202126121353"
      [mat-dialog-close]="button.value"
    >
      {{ button.text }}
    </button>
  </div>
</mat-dialog-content>
